/**
 * Borrowers 列表（/app/borrowers）。侧边栏 Borrowers。
 * 打开页面打 STATSIG.COMMON.VIEW，value=borrowers。
 *
 * 本轮只覆盖列表，不跨到档案页。
 */
export enum BorrowersEvent {
    /**
     * 点 Add borrower 打开弹窗。
     * value 与 metadata.type 相同：click_open_popup
     */
    ADD_BORROWER_BUTTON = 'BORROWERS_ADD_BORROWER_BUTTON',
    /**
     * 保存新借款人。value=loan_id
     */
    BORROWER_INSERT = 'BORROWERS_BORROWER_INSERT',
    /** 打开一个借款人。value=borrower_id */
    BORROWER_OPEN = 'BORROWERS_BORROWER_OPEN',
    /**
     * 删除借款人。单笔或批量都打一次。
     * value 与 metadata.type 相同：single|multiple
     * metadata.count=操作了几个；metadata.borrower_ids=对应 borrower_id 列表
     */
    BORROWER_DELETE = 'BORROWERS_BORROWER_DELETE',
}
